module.exports = __webpack_public_path__ + "img/2f352bddc941160844a8637a386da0d3.ttf";